module.exports = __webpack_public_path__ + "static/img/avatar_frame.44c4245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar_frame.png
// module id = E+z7
// module chunks = 1